import React from "react";

import Chip from "../index";

export default function Payroll({ value, ...props }) {
  const items = {
    DRAFT: {
      color: "default",
    },
    AUTHORISED: {
      color: "primary",
    },
    PAID: {
      color: "success",
    },
  };

  const item = items[value] || {
    color: "default",
  };

  return (
    <Chip color={item.color} tooltip={item.tooltip} value={value} {...props} />
  );
}
